<template>
  <v-card class="mx-3 my-3">
    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="listadoSucursalesConvenio.data"
        :loading="listadoSucursalesConvenio.loading"
        :items-per-page="10"
        :footer-props="{ itemsPerPageOptions: [10, 50, 100, 200] }"
        no-data-text="No se encontraron sucursales"
        item-key="_id"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Sucursales</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>

            <v-col class="justify-end d-flex">
              <!-- SLOT: BOTONES -->
              <slot></slot>
            </v-col>
          </v-toolbar>
          <v-divider />
        </template>

        <template v-slot:item.plazo_minimo_credito="{ item }">
          <div class="text-center">
            {{ item.plazo_minimo_credito || '--' }}
          </div>
        </template>

        <template v-slot:item.plazo_contrato_finalizar="{ item }">
          <div class="text-center">
            {{ item.plazo_contrato_finalizar || '--' }}
          </div>
        </template>

        <template v-slot:item.opciones="{ item }">
          <div class="text-no-wrap">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  class="mr-2"
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  small
                  @click="$emit('editar-convenio', item)"
                >
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'SucursalesConvenio',

  props: {
    listadoSucursalesConvenio: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        { text: 'Nombre', value: 'descripcion_sucursal' },
        {
          text: 'Antigüedad mayor a',
          value: 'plazo_minimo_credito',
          align: 'center',
        },
        {
          text: 'Plazo contratos a finalizar',
          value: 'plazo_contrato_finalizar',
          align: 'center',
        },
        {
          text: 'Opciones',
          value: 'opciones',
          sortable: false,
          align: 'center',
        },
      ],
    };
  },
};
</script>
